import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import Money from '../../../../common/money';

const List = ({ report, tipReport, history }) => {
  const columns = [{
    Header: '',
    accessor: 'name',
    className: 'u-text-center',
  }, {
    Header: 'Total Collected',
    accessor: 'total',
    className: 'u-text-center',
    Cell: props => <Money cents={props.value} />,
  }, {
    Header: 'Credit Card Fees',
    accessor: 'creditCardFees',
    className: 'u-text-center',
    Cell: props => <Money cents={props.value} />,
  }, {
    Header: 'Net Collected',
    accessor: 'netCollected',
    className: 'u-text-center',
    Cell: props => <Money cents={props.value} />,
  }, {
    Header: 'Commission %',
    accessor: 'percentage',
    className: 'u-text-center',
  }, {
    Header: 'Commission Due',
    accessor: 'commission',
    className: 'u-text-center',
    Cell: props => <Money cents={props.value} />,
  }, {
    Header: 'Cash Retained',
    accessor: 'cashRetained',
    className: 'u-text-center',
    Cell: props => <Money cents={props.value} />,
  }, {
    Header: history ? 'Transferred' : 'To be transferred',
    accessor: 'commissionDue',
    className: 'u-text-center',
    Cell: props => <Money cents={props.value} />,
  }];

  if (history) {
    columns.push({
      Header: 'Rapid Transfer Fees',
      accessor: 'instantPayoutFee',
      className: 'u-text-center',
      Cell: props => <Money cents={props.value} />,
    }, {
      Header: 'Deposited',
      accessor: 'commissionDeposited',
      className: 'u-text-center',
      Cell: props => <Money cents={props.value} />,
    });
  }

  return (
    <div>
      <h4>Commission</h4>
      <ReactTable
        minRows={0}
        showPagination={false}
        className="c-table-new c-table--small c-no-hover c-table--border"
        columns={columns}
        data={report}
      />
      <h4 className="u-mt">Tips</h4>
      <ReactTable
        minRows={0}
        showPagination={false}
        className="c-table-new c-table--small c-no-hover c-table--border"
        columns={[{
          Header: '',
          accessor: 'name',
          className: 'u-text-center',
        }, {
          Header: 'Tips',
          accessor: 'totalCollected',
          className: 'u-text-center',
          Cell: props => <Money cents={props.value} />,
        }, {
          Header: 'Cash Tip',
          accessor: 'cashTipAmount',
          className: 'u-text-center',
          Cell: props => <Money cents={props.value} />,
        }, {
          Header: 'Fees',
          id: 'fees',
          accessor: row => row.creditCardFee + row.instantPayoutFee,
          className: 'u-text-center',
          Cell: props => <Money cents={props.value} />,
        }, {
          Header: 'Tips Deposited',
          accessor: 'totalDeposited',
          className: 'u-text-center',
          Cell: props => <Money cents={props.value} />,
        }]}
        data={tipReport}
      />
    </div>
  );
};

List.propTypes = {
  history: PropTypes.bool,
};
List.defaultProps = {
  history: false,
};

export default List;
